module.exports = __webpack_public_path__ + "img/KE.431862e8.png";